export default __webpack_public_path__ + "static/support-sponsor-nytimes-74de1a3e0f04cf01219111c07529995a.png";